import { INITIAL_LOAN_TERM, MORTGAGE_BANNER_INTEREST_RATE } from '../../../constants/newbuildingMortgage';
import { calculateMonthlyPayment } from '../../../utils/motgageCalculator';

type BannerMonthlyPaymentParams = {
  price: number;
  loanTerm: number;
  firstPayment: number;
  initialFirstPayment: number;
  offersCount: number;
};

export function calculateBannerMonthlyPayment({
  price,
  loanTerm,
  firstPayment,
  initialFirstPayment,
  offersCount,
}: BannerMonthlyPaymentParams) {
  const monthlyPayment = calculateMonthlyPayment({
    initialPayment: firstPayment,
    interestRate: MORTGAGE_BANNER_INTEREST_RATE,
    loanTerm,
    price,
  });

  if (monthlyPayment === 0 || price < firstPayment || offersCount === 0) {
    return calculateMonthlyPayment({
      initialPayment: initialFirstPayment,
      interestRate: MORTGAGE_BANNER_INTEREST_RATE,
      loanTerm: INITIAL_LOAN_TERM,
      price,
    });
  }

  return monthlyPayment;
}
